import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import emailjs from '@emailjs/browser';
import "./index.less";

export default function ContactForm() {
    const { t } = useTranslation();
    const formRef = useRef();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState(false);

    useEffect(() => {
        emailjs.init("kT9QVsgOF8fizAXQx");
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError(false);

        console.log('Starting email submission...');

        const SERVICE_ID = 'service_nghxp57';
        const TEMPLATE_ID = 'template_5arszph';

        const templateParams = {
            from_name: formData.name,
            from_email: formData.email,
            phone: formData.phone || '未提供',
            message: formData.message,
            to_email: 'guohaolei@yunchijixie.com'
        };

        console.log('Template params:', templateParams);

        emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams)
            .then((response) => {
                console.log('Email sent successfully:', response);
                setIsSubmitting(false);
                setSubmitSuccess(true);
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    message: ""
                });
                
                setTimeout(() => {
                    setSubmitSuccess(false);
                }, 5000);
            })
            .catch((error) => {
                console.error('Email sending failed:', error);
                setIsSubmitting(false);
                setSubmitError(true);
                
                setTimeout(() => {
                    setSubmitError(false);
                }, 5000);
            });
    };

    return (
        <div className="contact-form-section">
            <div className="form-header">
                <h2>{t('contact.formTitle')}</h2>
                <p>{t('contact.formSubtitle')}</p>
            </div>
            
            {submitSuccess ? (
                <div className="form-success">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                        <polyline points="22 4 12 14.01 9 11.01"/>
                    </svg>
                    <h3>{t('contact.successTitle')}</h3>
                    <p>{t('contact.successMessage')}</p>
                </div>
            ) : submitError ? (
                <div className="form-error">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                    <h3>{t('contact.errorTitle') || '发送失败'}</h3>
                    <p>{t('contact.errorMessage') || '邮件发送失败，请稍后重试或直接联系我们。'}</p>
                </div>
            ) : (
                <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor="name">{t('contact.name')} *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder={t('contact.namePlaceholder')}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">{t('contact.email')} *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder={t('contact.emailPlaceholder')}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">{t('contact.phone')}</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder={t('contact.phonePlaceholder')}
                            />
                        </div>
                        <div className="form-group form-group-full">
                            <label htmlFor="message">{t('contact.message')} *</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows={6}
                                placeholder={t('contact.messagePlaceholder')}
                            />
                        </div>
                    </div>
                    <div className="form-actions">
                        <button 
                            type="submit" 
                            className="submit-btn"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? t('contact.submitting') : t('contact.submit')}
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
}